import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollFix = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.history.scrollRestoration = "manual";
  }, [pathname]);
  return null;
};

export default ScrollFix;